export const menuLinks = [
    {
        text: 'ESERCIZI',
        href: '/search'
    },
    {
        text: 'VERIFICHE PRONTE',
        href: '/zLibrary'
    },
    {
        text: 'IL TUO ARCHIVIO',
        href: '/myLibrary'
    }
];

export const footerLinks = [
    {
        text: 'CREDITS',
        href: '/credits'
    }
];
